import React, { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { UserRole } from "@green0meter/api-client";

import { VsmeDashboardOverview, VsmeRecommendations } from "@components/main/vsme";
import { VsmeBreakdownByEntities } from "@components/main/vsme/dashboard";
import { Box, Grid } from "@components/base";
import { useUserStore } from "@store/user";

const VsmeDashboardPage: FC = () => {
  const location = useLocation();
  const { user } = useUserStore();

  const isNotViever = user?.role !== UserRole.Viewer && user?.role !== UserRole.Auditor;

  useEffect(() => {
    const scrollToId =
      location.state?.scrollTo ||
      new URLSearchParams(location.search).get("scrollTo");

    if (scrollToId) {
      const element = document.getElementById(scrollToId);

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          inline: "start",
          block: "start",
        });
      }
    }
  }, [location]);

  return (
    <Box mb={6}>
      <Grid container spacing={3}>
        <Grid id={"overview"} size={12}>
          <VsmeDashboardOverview />
        </Grid>
        {isNotViever && (
          <Grid id={"recommendations"} size={12}>
            <VsmeRecommendations />
          </Grid>
        )}
        <Grid id={"pbi-reports"} size={12}>
          <VsmeBreakdownByEntities />
        </Grid>
      </Grid>
    </Box>
  );
};

export default VsmeDashboardPage;
